import {
  TOGGLE_USER_ROLES_START,
  TOGGLE_USER_ROLES_SUCCESS,
  TOGGLE_USER_ROLES_FAILURE,
} from 'constants/action-types/user/toggleUserRoles';
import apiAction from 'helpers/apiAction';
import notification from 'helpers/notificationHelper';
import getUserRoles from './getUserRoles';

export default (userId, action, data) => (dispatch, setPinModal) =>
  dispatch(
    apiAction({
      url: `admin/users/${userId}/${action}`,
      data,
      method: 'PUT',
      API_REQUEST_START: TOGGLE_USER_ROLES_START,
      API_REQUEST_FAILURE: TOGGLE_USER_ROLES_FAILURE,
      API_REQUEST_SUCCESS: TOGGLE_USER_ROLES_SUCCESS,
      onSuccess: ({ message }) => {
        dispatch({
          type: TOGGLE_USER_ROLES_SUCCESS,
          payload: message,
        });
        getUserRoles(userId)(dispatch);
        setPinModal(false);
        notification({ message });
      },
      onFailure: ({ message }) => {
        dispatch({
          type: TOGGLE_USER_ROLES_FAILURE,
          payload: message,
        });
        if (message !== 'Wrong PIN.') {
          setPinModal(false);
          notification({ message, status: 'error' });
        }
      },
      onEnd: () => false,
    }),
  );
